import React from 'react';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import { T } from '@colonist/ui';
import { getHelperText } from '../utils.ts';
import IconSpecialBuildPhaseFlag from '@static/images/icon_special_build_phase_flag.svg';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { TurnState } from '@colonist/game-states';
export const UIGameActionButtonSpecialBuildPhase = ({ className, hideTooltip })=>{
    const myColor = useGameStore((state)=>state.myColor);
    const isPaused = useGameStore((state)=>state.gamePause.isPaused);
    const { sendRequestSpecialBuildPhase, sendCancelSpecialBuildPhase } = useGameStore((state)=>state.gameSendEvent);
    const isRequestingSpecialBuildPhase = useGameStore((state)=>{
        var _state_gameState_mechanicSpecialBuildPhaseState_playerStates_myColor, _state_gameState_mechanicSpecialBuildPhaseState_playerStates, _state_gameState_mechanicSpecialBuildPhaseState;
        return ((_state_gameState_mechanicSpecialBuildPhaseState = state.gameState.mechanicSpecialBuildPhaseState) === null || _state_gameState_mechanicSpecialBuildPhaseState === void 0 ? void 0 : (_state_gameState_mechanicSpecialBuildPhaseState_playerStates = _state_gameState_mechanicSpecialBuildPhaseState.playerStates) === null || _state_gameState_mechanicSpecialBuildPhaseState_playerStates === void 0 ? void 0 : (_state_gameState_mechanicSpecialBuildPhaseState_playerStates_myColor = _state_gameState_mechanicSpecialBuildPhaseState_playerStates[myColor]) === null || _state_gameState_mechanicSpecialBuildPhaseState_playerStates_myColor === void 0 ? void 0 : _state_gameState_mechanicSpecialBuildPhaseState_playerStates_myColor.isRequesting) || false;
    });
    const currentState = useGameStore((state)=>state.gameState.currentState);
    const isInitialPlacement = currentState.turnState === TurnState.InitialPlacement;
    const disabled = isPaused || isInitialPlacement;
    const onClick = ()=>{
        if (disabled) return;
        if (isRequestingSpecialBuildPhase) {
            sendCancelSpecialBuildPhase();
        } else {
            sendRequestSpecialBuildPhase();
        }
    };
    const helperText = getHelperText({
        isInitialPlacement: isInitialPlacement
    });
    const tooltipContent = (()=>{
        if (hideTooltip) return undefined;
        if (isRequestingSpecialBuildPhase) return /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.withdrawRequestSpecialBuildPhase"
        });
        return /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.requestSpecialBuildPhase"
        });
    })();
    return /*#__PURE__*/ React.createElement(UIGameActionButton, {
        className: className,
        highlight: isRequestingSpecialBuildPhase,
        disabled: disabled,
        helperText: helperText,
        iconPath: IconSpecialBuildPhaseFlag,
        centerTextTooltip: true,
        tooltipTitle: tooltipContent,
        onClick: onClick
    });
};
